// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b669168","239":"be0d2136","455":"ba1d365f"}[chunkId] + ".chunk.js";
};